import {
  SEX_FEMALE,
  SEX_MALE,
  TYPE_CAT,
  TYPE_DOG,
  BIG,
  MEDIUM,
  SMALL,
} from "../constants/constants";

class DataNormalization {
  static petTypeString(type) {
    if (type === TYPE_DOG) {
      return "Perro";
    }

    if (type === TYPE_CAT) {
      return "Gato";
    }
  }

  static petSexString(sex) {
    if (sex === SEX_MALE) {
      return "Macho";
    }

    if (sex === SEX_FEMALE) {
      return "Hembra";
    }
  }

  static petSexMostVisits(sex) {
    if (sex === SEX_MALE) {
      return "El más visto";
    }

    if (sex === SEX_FEMALE) {
      return "La más vista";
    }
  }

  static petSizeString(size, sex=SEX_MALE) {
    if (size === BIG) {
      return "Grande";
    }

    if (size === MEDIUM) {
      if (sex === SEX_MALE) {
        return "Mediano";
      } else {
        return "Mediana";
      }
    }

    if (size === SMALL) {
      if (sex === SEX_MALE) {
        return "Pequeño";
      } else {
        return "Pequeña";
      }
    }
  }

  static petFurString(size) {
    if (size === BIG) {
      return "Largo";
    }

    if (size === MEDIUM) {
      return "Mediano";
    }

    if (size === SMALL) {
      return "Corto";
    }
  }

  static petVaccinated(vaccinated, sex = SEX_MALE) {
    if (sex === SEX_MALE) {
      return "Vacunado";
    }

    if (sex === SEX_FEMALE) {
      return "Vacunada";
    }
  }

  static petFixed(fixed, sex = SEX_MALE) {
    if (sex === SEX_MALE) {
      return "Castrado";
    }

    if (sex === SEX_FEMALE) {
      return "Castrada";
    }
  }

  static petNoParasites(noparasites, sex = SEX_MALE) {
    if (sex === SEX_MALE) {
      return "Desparasitado";
    }

    if (sex === SEX_FEMALE) {
      return "Desparasitada";
    }
  }

  static petAge(age) {
    const ageToYears = age / 12;

    if (ageToYears >= 1) {
    const roundAge = Math.floor(ageToYears);
      return `${roundAge} ${roundAge === 1? 'año': 'años'}`;
    } else {
        return `${age} ${age === 1? 'mes': 'meses'}`;
    }
  }

  static getRandomInt(max = 1) {
    return Math.floor(Math.random() * max);
  }

  static firtsUpperOthersLower(data) {
    let temp = data.substring(0,1);
    let temp2 = data.substring(1).toLowerCase();
    return `${temp.toUpperCase()}${temp2}`;
  }
}

export default DataNormalization;
